import { useState } from 'react';
import AvailabilityActorsTable from './actors-table';
import './availability.scss';
import Moment from "react-moment";
import { CSVLink } from 'react-csv';
import FilmanizeCheckbox from '../../../shared/filmanize-checkbox';

const Availability = ({
  filmId,
  potentialDates,
  datesTotals,
  actorsAvailability,
  backgroundActorsAvailability,
  crewMemberAvailability,
  locationsAvailability,
  canAccessActors,
  canAccessBackgroundActors,
  canAccessCrew,
  readOnly,
  filmName,
  csvData,
  updatePersonAvailability,
  hasChanges,
  onSaveAvailability,
  onCancelAvailabilityEdit }) => {

  const filteredPotentialDates = potentialDates.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()).map((potentialDate) => {
    return { date: new Date(potentialDate.date).toDateString(), id: potentialDate.id }; // Parse the local date   
  });

  const [showScrollBars, setShowScrollBars] = useState(true);
  const [editMode, setEditMode] = useState(false);

  const handleAvailabilityChange = (personType, personId, date, isAvailable) => {
    if (updatePersonAvailability) {
      updatePersonAvailability(personType, personId, date, isAvailable);
    }
  };

  const handleSaveChanges = () => {
    if (onSaveAvailability) {
      onSaveAvailability();
    }
    setEditMode(false);
  };

  const handleCancelEdit = () => {
    if (onCancelAvailabilityEdit) {
      onCancelAvailabilityEdit();
    }
    setEditMode(false);
  };

  const crewMemberLinkGenerator = (crewMember) => {
    return `/films/${filmId}/departments/${crewMember.crewDepartmentId}/roles/${crewMember.crewRoleId}/members/${crewMember.id}/edit`;
  }

  return (
    <section>
      <div className="day-out-days-table-container" style={{ maxWidth: showScrollBars ? '50rem' : 'auto', maxHeight: showScrollBars ? '50rem' : 'auto', overflow: showScrollBars ? 'auto' : 'inherit' }}>
        <table className="table day-out-days-table">
          <thead className="day-out-days-table-header-row">
            <tr>
              <th className="day-out-days-table-actor-column-header">Date</th>
              <th></th>
              {(filteredPotentialDates || []).map((potentialDate: any, index: number) => (<th className="has-text-centered" key={index}><Moment format="ddd">{potentialDate.date}</Moment><br /><Moment format="DD/MM/YYYY">{potentialDate.date}</Moment></th>))}
            </tr>
            <tr>
              <th className="day-out-days-table-actor-column-header">Total</th>
              <th></th>
              {(datesTotals || []).map((total: any, index: number) => (<th className="has-text-centered" key={index}>{total}</th>))}
            </tr>
          </thead>
          <tbody>
            {actorsAvailability?.length > 0 && <>
              <tr>
                <th className="day-out-days-table-actor-column has-text-weight-bold">Actors</th><td colSpan={filteredPotentialDates.length + 1}></td>
              </tr>
              <AvailabilityActorsTable
                potentialDates={filteredPotentialDates}
                people={actorsAvailability}
                filmId={filmId}
                sectionLink="actors"
                canAccess={canAccessActors}
                editMode={editMode}
                personType="actor"
                onAvailabilityChange={handleAvailabilityChange} />
            </>}
            {backgroundActorsAvailability?.length > 0 && <> <tr>
              <th className="day-out-days-table-actor-column has-text-weight-bold">Background Actors</th><td colSpan={filteredPotentialDates.length + 1}></td>
            </tr>
              <AvailabilityActorsTable
                potentialDates={filteredPotentialDates}
                people={backgroundActorsAvailability}
                filmId={filmId}
                sectionLink="background-actors"
                canAccess={canAccessBackgroundActors}
                editMode={editMode}
                personType="background-actor"
                onAvailabilityChange={handleAvailabilityChange} />
            </>
            }
            {crewMemberAvailability?.length > 0 && <>
              <tr>
                <th className="day-out-days-table-actor-column has-text-weight-bold">Crew</th><td colSpan={filteredPotentialDates.length + 1}></td>
              </tr>
              <AvailabilityActorsTable
                potentialDates={filteredPotentialDates}
                people={crewMemberAvailability}
                filmId={filmId}
                sectionLink="crew"
                canAccess={canAccessCrew}
                linkGenerator={crewMemberLinkGenerator}
                editMode={editMode}
                personType="crew"
                onAvailabilityChange={handleAvailabilityChange} />
            </>}
            {locationsAvailability?.length > 0 && <> <tr>
              <th className="day-out-days-table-actor-column has-text-weight-bold">Locations</th><td colSpan={filteredPotentialDates.length + 1}></td>
            </tr>
              <AvailabilityActorsTable
                potentialDates={filteredPotentialDates}
                people={locationsAvailability}
                filmId={filmId}
                sectionLink="locations"
                canAccess={canAccessBackgroundActors}
                isLocation={false}
                editMode={editMode}
                personType="location"
                onAvailabilityChange={handleAvailabilityChange} />
            </>
            }
          </tbody>
        </table>
      </div>

      {!readOnly && (
        <div className="buttons mb-2 mt-1">
          {!editMode ? (
            <button className="button" onClick={() => setEditMode(true)}>
              {/* <span className="icon"><i className="material-icons">edit</i></span> */}
              <span>Edit Availability</span>
            </button>
          ) : (
            <>
              <button className="button is-primary" onClick={handleSaveChanges} disabled={!hasChanges}>
                {/* <span className="icon"><i className="material-icons">save</i></span> */}
                <span>Save Changes</span>
              </button>
              <button className="button" onClick={handleCancelEdit}>
                {/* <span className="icon"><i className="material-icons">close</i></span> */}
                <span>Cancel</span>
              </button>
            </>
          )}
        </div>
      )}

      <div className='buttons mt-1'>
        {csvData && <CSVLink className="button" data={csvData} filename={`${filmName} Availability`}>Download CSV</CSVLink>}
      </div>

    </section>
  );
};



export default Availability;
